__turbopack_context__.v({
  "Button": "index-module__l9G5qW__Button",
  "Error": "index-module__l9G5qW__Error",
  "Field": "index-module__l9G5qW__Field",
  "Form": "index-module__l9G5qW__Form",
  "Input": "index-module__l9G5qW__Input",
  "Label": "index-module__l9G5qW__Label",
});
